

export const WindyColorScale = [
    "rgb(255, 255, 255)",
    "rgb(255, 255, 170)",
    "rgb(255, 255, 85)",
    "rgb(255, 255, 0)", // 3
    "rgb(255, 224, 0)",
    "rgb(255, 193, 0)",
    "rgb(255, 159, 0)",
    "rgb(255, 127, 0)", // 7
    "rgb(255, 96, 0)",
    "rgb(255, 64, 0)",
    "rgb(255, 32, 0)",
    "rgb(255, 0, 0)", // 11
    "rgb(170, 0, 170)",
    "rgb(85, 0, 170)",
];

WindyColorScale.indexFor = function(v) {
    if (v < 10.8) {
        return 0
    }
    // TD~
    if (v < 13.9) {
        return 1
    }
    if (v < 17.2) {
        return 2
    }
    // 輕度颱風~
    if (v < 20.8) {
        return 3
    }
    if (v < 24.5) {
        return 4
    }
    if (v < 28.5) {
        return 5
    }
    if (v < 32.7) {
        return 6
    }
    // 中度颱風~
    if (v < 37.0) {
        return 7
    }
    if (v < 41.5) {
        return 8
    }
    if (v <46.2) {
        return 9
    }
    if (v < 51.0) {
        return 10
    }
    // 強度颱風~
    if (v < 56.1) {
        return 11
    }
    if (v < 61.2) {
        return 12
    }
    // 超過17級風~
    return 13
};

export const WindyOption = {
    colorScale: WindyColorScale,
    particleMultiplier: (1.0/200),
    frameRate: 30,
    worker_uri: null,
    opacity: 1,
    lineWidth: 0.5
}
